export const divIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V18.1829C1.53659 18.8901 2.10988 19.4634 2.81707 19.4634H18.1829C18.8901 19.4634 19.4634 18.8901 19.4634 18.1829V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V18.1829C0 19.7388 1.26125 21 2.81707 21H18.1829C19.7388 21 21 19.7388 21 18.1829V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1341 4.60976H4.86585C4.72442 4.60976 4.60976 4.72441 4.60976 4.86585V9.9878C4.60976 10.1292 4.72441 10.2439 4.86585 10.2439H16.1341C16.2756 10.2439 16.3902 10.1292 16.3902 9.9878V4.86585C16.3902 4.72441 16.2756 4.60976 16.1341 4.60976ZM4.86585 3.07317C3.87578 3.07317 3.07317 3.87578 3.07317 4.86585V9.9878C3.07317 10.9779 3.87578 11.7805 4.86585 11.7805H16.1341C17.1242 11.7805 17.9268 10.9779 17.9268 9.9878V4.86585C17.9268 3.87578 17.1242 3.07317 16.1341 3.07317H4.86585Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3902 14.3415H4.60976V16.3902H16.3902V14.3415ZM4.60976 12.8049C3.76112 12.8049 3.07317 13.4928 3.07317 14.3415V16.3902C3.07317 17.2389 3.76112 17.9268 4.60976 17.9268H16.3902C17.2389 17.9268 17.9268 17.2389 17.9268 16.3902V14.3415C17.9268 13.4928 17.2389 12.8049 16.3902 12.8049H4.60976Z"
      fill="#6B00DF"
    />
  </svg>
);
